import React from 'react';
import { useState } from 'react';
import VendorChildHead from './vendorChildHead';
// material
import {
    Table,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    Autocomplete,
    Switch,
    FormControlLabel,
    IconButton,
    InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import EditTextField from '../../../overrides/editField';


const TABLE_HEAD = [
    { id: 'landLineNumber ', label: 'Landline Number ', alignRight: false },
    { id: 'mobileNumber', label: 'Mobile Number', alignRight: false },
    { id: 'emailID', label: 'Email ID', alignRight: false },
    { id: 'status', label: 'Payment Status', alignRight: false },
    { id: 'gateway', label: 'Payment Gateway', alignRight: false },
    { id: 'key', label: 'Payment Key', alignRight: false },
    { id: 'secret', label: 'Payment Secret', alignRight: false }
];

const VendorChildTable = ({ expandOpen, rowData, handleEditChange, status, editData, setEditData, formErrors, clearFormError }) => {

    const { VendorReducers: { getPaymentGateway } } = useSelector(state => state)

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [showSecret, setShowSecret] = useState(false);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const isPaymentEnabled = rowData.gateway_allowed === 1 || rowData.gateway_allowed === true;

    const gatewayName = rowData.gateway_name || (getPaymentGateway || []).find(
        (g) => Number(g.gateway_id) === Number(rowData.gateway_id)
    )?.gateway_name;

    return (
        <>
            {expandOpen &&
                <TableContainer sx={{ overflow:'unset' }}>
                    <Table>
                        <VendorChildHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            //   rowCount={USERLIST.length}
                            //   numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            <TableRow
                                // hover
                                tabIndex={-1}
                                sx={{ '& > *': { borderBottom: 'unset' } }}
                            >
                                {status === 'list' ?
                                    <>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CLANDLINENUMBER}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CMOBILENUMBER}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.CEMAILID}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {isPaymentEnabled ? 'Enabled' : 'Disabled'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {gatewayName}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.payment_key}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t14_600'>
                                                {rowData.payment_secret ? '••••••' : ''}
                                            </Typography>
                                        </TableCell>
                                    </>
                                    :
                                    <>
                                        <TableCell align="left">
                                            <EditTextField
                                                name='CLANDLINENUMBER'
                                                value={editData.CLANDLINENUMBER}
                                                onChange={handleEditChange}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <EditTextField
                                                name='CMOBILENUMBER'
                                                value={editData.CMOBILENUMBER}
                                                onChange={handleEditChange}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <EditTextField
                                                name='CEMAILID'
                                                value={editData.CEMAILID}
                                                onChange={handleEditChange}
                                            />
                                        </TableCell>

                                        <TableCell align="left">
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={!!editData.GATEWAY_ALLOWED}
                                                        onChange={(e) =>
                                                            setEditData({
                                                                ...editData,
                                                                GATEWAY_ALLOWED: e.target.checked,
                                                            })
                                                        }
                                                        color="success"
                                                    />
                                                }
                                                label={editData.GATEWAY_ALLOWED ? 'Enabled' : 'Disabled'}
                                            />
                                        </TableCell>

                                        <TableCell align="left">
                                            {editData.GATEWAY_ALLOWED && (
                                                <Autocomplete
                                                    size="small"
                                                    options={getPaymentGateway || []}
                                                    getOptionLabel={(o) => o.gateway_name}
                                                    value={
                                                        (getPaymentGateway || []).find(
                                                            (g) => Number(g.gateway_id) === Number(editData.GATEWAY_ID)
                                                        ) || null
                                                    }
                                                    onChange={(e, v) => {
                                                        setEditData({
                                                            ...editData,
                                                            GATEWAY_ID: v ? Number(v.gateway_id) : null,
                                                        });
                                                        clearFormError('GATEWAY_ID');
                                                    }}
                                                    renderInput={(p) => (
                                                        <EditTextField
                                                            {...p}
                                                            error={Boolean(formErrors.GATEWAY_ID)}
                                                            helperText={formErrors.GATEWAY_ID}
                                                        />
                                                    )}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="left">
                                            {editData.GATEWAY_ALLOWED && (
                                                <EditTextField
                                                    name='PAYMENT_KEY'
                                                    value={editData.PAYMENT_KEY || ''}
                                                    onChange={handleEditChange}
                                                    error={Boolean(formErrors.PAYMENT_KEY)}
                                                    helperText={formErrors.PAYMENT_KEY}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="left">
                                            {editData.GATEWAY_ALLOWED && (
                                                <EditTextField
                                                    name='PAYMENT_SECRET'
                                                    type={showSecret ? 'text' : 'password'}
                                                    value={editData.PAYMENT_SECRET || ''}
                                                    onChange={handleEditChange}
                                                    error={Boolean(formErrors.PAYMENT_SECRET)}
                                                    helperText={formErrors.PAYMENT_SECRET}
                                                    autoComplete="new-password"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => setShowSecret(!showSecret)}>
                                                                    {showSecret ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                        </TableBody>

                    </Table>
                </TableContainer>
            }
        </>
    )
}

export default VendorChildTable;